import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../medieval-office-kit';

const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art, f } = ctx;

  // Cold flagstone runner from the gate, leading deeper into the keep.
  place(ctx, kit.runnerRug(art, 90, 360), 1450, 980);

  // HERO: the portcullis arch framing the west gate (just inside the portcullis gap).
  place(ctx, kit.portcullisArch(art), 1360, 730);

  // A 'welcome' banner hung high above the gate.
  place(ctx, kit.banner(art, undefined, 90), 1450, 648);

  // Two suit-of-armour sentinels standing watch, flanking the gate.
  place(ctx, kit.suitOfArmour(art), 1400, 650);
  place(ctx, kit.suitOfArmour(art), 1400, 820);

  // Arrival benches along the side walls (AT the seat anchors).
  place(ctx, kit.pew(art, 70), 1400, 1000); // gatehouse-bench-l, facing 0
  place(ctx, kit.pew(art, 70), 1500, 1000); // gatehouse-bench-r, facing π

  // Guest ledger lectern by the inner threshold.
  place(ctx, kit.lectern(art), 1500, 910);

  // Warm but DIM — two wall torches + a single brazier (the bright hall beyond is a lift).
  place(ctx, kit.wallTorch(art), 1360, 900);
  place(ctx, kit.wallTorch(art), 1540, 900);
  place(ctx, kit.brazier(art), 1450, 1110);

  // Ivy so the cold stone corner reads warm.
  place(ctx, f.plant(art, 'leafy'), 1530, 1000);
};

export default decorate;
